
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/fresh-finds",
      function () {
        return require("private-next-pages/tools/fresh-finds/index.tsx");
      }
    ]);
  